import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { ButtonActive, TYPE_CALENDAR } from 'widgets/tour/date-range-picker'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { ButtonContinue } from 'shared/ui/bottom-continue'

import s from './styles.module.scss'

interface Props extends ButtonActive {}

const listCalendarAction: TYPE_CALENDAR[] = [
  'excursion',
  'insuranceYear',
  'beket',
]

const getCurrentType = (type: TYPE_CALENDAR | undefined) => {
  if (!type) return false

  return listCalendarAction?.includes(type)
}

export const ButtonCalendar: FC<Props> = ({
  typeCalendar,
  selectedDates,
  confirmText,
  onClick,
}) => {
  const { t } = useTranslation()

  const currentType = getCurrentType(typeCalendar)

  if (typeCalendar === 'avia' && selectedDates?.startDate) {
    return (
      <ButtonContinue onClick={onClick}>
        {selectedDates?.startDate && !selectedDates?.endDate && (
          <span className={s.text}>{t('doesnt_need_return_ticket')}</span>
        )}

        {selectedDates?.startDate && selectedDates?.endDate && (
          <span className={s.text}>
            {t('select', {
              date: `${dateFormat(selectedDates.startDate, DATE_FORMAT_LIST.DATE_MONTH_SHORT)} - ${dateFormat(selectedDates.endDate, DATE_FORMAT_LIST.DATE_MONTH_SHORT)}`,
            })}
          </span>
        )}
      </ButtonContinue>
    )
  }

  if (typeCalendar === 'aviaDifficult' && selectedDates?.startDate) {
    return (
      <ButtonContinue onClick={onClick}>
        <span className={s.text}>{t('continue')}</span>
      </ButtonContinue>
    )
  }

  if (typeCalendar === 'insurance') {
    return (
      <ButtonContinue
        disabled={!selectedDates?.startDate || !selectedDates?.endDate}
        onClick={onClick}
      >
        <span className={s.text}>{confirmText || t('save')}</span>
      </ButtonContinue>
    )
  }

  if (typeCalendar === 'beket' && selectedDates?.startDate) {
    return (
      <ButtonContinue onClick={onClick}>
        <span className={s.text}>
          {t('select', {
            date: dateFormat(
              selectedDates.startDate,
              DATE_FORMAT_LIST.DATE_MONTH_SHORT,
            ),
          })}
        </span>
      </ButtonContinue>
    )
  }

  if (typeCalendar === 'tour' && selectedDates?.startDate) {
    return (
      <ButtonContinue onClick={onClick}>
        <span className={s.text}>
          {t('tours_block.departure', {
            date: dateFormat(
              selectedDates.startDate,
              DATE_FORMAT_LIST.DATE_MONTH,
            ),
          })}
        </span>
      </ButtonContinue>
    )
  }

  if (currentType && selectedDates?.startDate) {
    return (
      <ButtonContinue onClick={onClick}>
        <span className={s.text}>{t('continue')}</span>
      </ButtonContinue>
    )
  }

  return null
}
